<template>
    <el-dialog :visible.sync="dialogValue"
               title="素材修改"
               custom-class="material-edit-dialog"
               class="global-dialog"
               width="800px"
               :modal="false"
               :append-to-body="true"
               :close-on-click-modal="false">
        <div v-if="data" class="med-content">
            <div class="med-tools">
                <div>
                    <p class="c-flex">
                        <label>高 </label>
                        <el-input-number v-model="container.height" size="small"
                                         controls-position="right"></el-input-number>
                    </p>
                    <p class="c-flex">
                        <label>宽 </label>
                        <el-input-number v-model="container.width" size="small"
                                         controls-position="right"></el-input-number>
                    </p>
                </div>
            </div>
            <div class="med-right">
                <div class="scale-box" :style="scaleBoxStyle">
                    <div :style="calcStyle">
                        <div class="img-opacity-box" :style="{width: `${container.width}px`, height: `${container.height}px`}">
                            <draggable-resize
                                    class="c-resize-border"
                                    @dragstop="onDragstop"
                                    :scale-ratio="scale"
                                    :parent="false"
                                    :active="true"
                                    :draggable="true"
                                    :resizable="false"
                                    :w="boxObj.width"
                                    :h="boxObj.height"
                                    :x="boxObj.left"
                                    :y="boxObj.top">
                                <img :src="boxObj.url" class="m-img"/>
                            </draggable-resize>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 0px;overflow: auto">
                <div class="img-opacity-box" ref="imgRef" :style="{backgroundColor: 'RGBA(0,0,0,0)', width: `${container.width}px`, height: `${container.height}px`}">
                        <img :src="boxObj.url" class="m-img" :style="screenshotImgStyle"/>
                </div>
            </div>
        </div>
        <div slot="footer">
            <el-button @click="onCancel">取消</el-button>
            <el-button type="primary" @click="onSave" :loading="loading">完成编辑</el-button>
        </div>
    </el-dialog>
</template>
<script>
  import util from '@/util.js';
  import draggableResize from '../../components/draggable-resize/draggable-resizable';
  export default {
    components:{draggableResize},
    props: {
      value: {type: Boolean, default: false},
      data: Object,
    },
    data() {
      return {
        loading: false,
        dragVisible: false,
        container:{
          width: null,
          height: null
        },
        boxObj: {
          originId: -1,
          width: 0,
          height: 0,
          left: 0,
          top: 0
        }
      }
    },
    computed: {
      dialogValue: {
        get() {
          return this.value;
        },
        set(v) {
          this.$emit('input', v);
        }
      },
      scale(){
        return  util.getScaleWidthAndHeight(500, 400 , this.boxObj.width, this.boxObj.height);
      },
      calcStyle(){
        return `transform: scale(${this.scale})`
      },
      scaleBoxStyle(){
        let width = this.boxObj.width, height = this.boxObj.height;
        let scale = this.scale;
        let w = width * scale, h = height * scale;
        return `width: ${w}px; height: ${h}px`
      },
      screenshotImgStyle(){
        let {left, top} = this.boxObj;
        return `position:absolute;left: ${left}px; top: ${top}px;`
      }
    },
    watch: {
      value(v) {
        if (v) {
          this.init();
        }
      }
    },
    created() {
    },
    methods: {
      init() {
        let {width, height, url} = this.data;
        this.boxObj.width = +width;
        this.boxObj.height = +height;
        this.boxObj.url = url;
        this.boxObj.left = 0;
        this.boxObj.top = 0;
        this.container.width = +width;
        this.container.height = +height;
        this.dragVisible = true;
      },
      onCancel() {
        this.$emit('input', false);
      },
      onSave() {
        this.loading = true;
        setTimeout(() => {
          let width = this.container.width, height = this.container.height;
          util.html2ImgUrl(this.$refs.imgRef, width, height).then((url) => {
            this.$emit('onConfirm', url, width, height);
          }).finally(() => {
            this.loading = false;
          });
        })
      },
      onDragstop(left, top, width, height){
        this.boxObj.left = left;
        this.boxObj.top = top;
      },
    }
  }
</script>
<style lang="scss">
    @import "./material-edit-dialog";
</style>